import { useEffect, useState } from "react";
import { useEmpleo } from "../../../Empresas/Empleos/Hooks/HookEmpleo";

const usePostulaciones = () => {
    const { loading, empleos, getEmpleosNoAplicadosByEgredado, postularEgresadoAEmpleo } = useEmpleo();

    const [busqueda, setBusqueda] = useState(''); 

    const fetchData = async () => {
        await getEmpleosNoAplicadosByEgredado();
    }

    // Filtrar empleos según la búsqueda
    const empleosFiltrados = empleos?.filter((empleo) => {
        const busquedaLower = busqueda.toLowerCase();
        return (
            empleo.titulo.toLowerCase().includes(busquedaLower) ||
            empleo.ubicacion.toLowerCase().includes(busquedaLower) ||
            empleo.habilidades_requeridas.toLowerCase().includes(busquedaLower) ||
            empleo.tipo_empleo.toLowerCase().includes(busquedaLower) ||
            empleo.descripcion.toLowerCase().includes(busquedaLower) ||
            empleo.salario.toLowerCase().includes(busquedaLower)||
            empleo.empresa?.razon_social.toLowerCase().includes(busquedaLower)
        );
    }) || [];
    
    useEffect(() => {
        fetchData();
    }, []);

    return { loading, empleosFiltrados, busqueda, setBusqueda, postularEgresadoAEmpleo };
}

export default usePostulaciones;